export default function (element, data) {
    window.addEventListener("open-mobile-menu", function () {
        element.classList.add("open");
        document.body.classList.add('no-scroll');
    });

    window.addEventListener("close-mobile-menu", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });

    var closeElement = element.querySelector('.close');
    closeElement.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-mobile-menu'));
    });

    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-mobile-menu'));
    });
    
    element.querySelector(".menu-mobile").addEventListener("click", function (event) {
        event.stopPropagation();
    });

    var menuLinks = element.querySelectorAll('.menu__item');
    menuLinks.forEach(item => {
        item.addEventListener("click", function (event) {
            window.dispatchEvent(new CustomEvent('close-mobile-menu'));
        });
    });
};